import React, { Component } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { connect } from 'react-redux'
import { Colors, Table, TableHeader, TableExpander, TableLoading, Pagination } from 'advenio-components'
import Subcomponent from './Subcomponent'
import { formatPrice } from '../../../utils/Utils'


const TableContainer = styled.div`
  width: 100%;
`

const Data = styled.div`
  width: 100%;
  height: 60px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #637381;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: normal;
  overflow: hidden;
  padding: 5px;
  box-sizing: border-box;
  @media (max-width:767px) {
    height: 90px;
  }
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const Type = styled(Data)`
  ${({ type }) => type === 'Payment' && `color: ${Colors.green600};`}
`

class BalanceTable extends Component {
  state = {
    balance: [],
    expanded: [],
  }

  componentWillReceiveProps = ({ balance }) => {
    // const newBalance = this.getFilterBalanceRow(balance)
   
    this.setState({ balance: balance.data })
  }

  // getFilterBalanceRow = (balance) => {
  //   const dates = new Set()
  //   const filteredRows = []

  //   balance.map((row) => {
  //     dates.add(moment(row.registered_at).format('DD MMM YYYY'))
  //     return null
  //   })
  //   dates.forEach((date) => {
  //     filteredRows.push({
  //       date,
  //       rows: this.divideRowsPerDate(date, balance),
  //     })
  //   })
  //   return filteredRows
  // }

  openRow = (index) => {
    const newState = { ...this.state }
    if (newState.expanded[index]) {
      newState.expanded[index] = false
    } else {
      newState.expanded[index] = true
    }
    this.setState(newState)
  }

  // divideRowsPerDate = (date, balance) => balance.filter(row => moment(row.registered_at).format('DD MMM YYYY') === date)

  onClickPage = (pageSelected) => {
    // this.setState({ pageSelected }, () => {
    //   // const queries = { ...this.state.queryParams, page: pageSelected }
    //   const {activeStudentId} =this.props;
    //   // this.props.getReceipts(queries)
      this.props.getMore(pageSelected)
      //  this.props.goTo(`?${queryString.stringify(queries)}`)

    // })
  }

  render() {
    const { loading, child: { currency }, child, pageSelected } = this.props
    const { balance, expanded } = this.state
    return (
      <TableContainer>
             <PaginationContainer>
                  <Pagination
                  totalElements={this.props.balance.meta && this.props.balance.meta.total}
                  elementsPerPage={this.props.balance.meta && this.props.balance.meta.per_page}
                  onPageClick={this.onClickPage}
                  pageSelected={pageSelected}
                 />
              </PaginationContainer>
        { /*(balance.length > 0) &&*/ !loading  ? (
          <Table
            SubComponent={Subcomponent}
            data={balance}
            expanded={expanded}
            hover
            columns={[
              {
                expander: true,
                Header: () => <TableHeader blue />,
                Expander: ({ isExpanded, ...rest }) =>
                  (<Data>
                    <TableExpander
                      id={rest.index}
                      open={isExpanded}
                      openCard={() => this.openRow(rest.index)}
                    />
                  </Data>),
              },
              {
                id: 'description',
                Header: () => <TableHeader title="Descripción" blue center noEllipsis />,
                accessor: ({ description }) => ({ description }),
                Cell: ({ value: { description }, index }) => (
                    <Data onClick={() => this.openRow(index)}>{description}</Data>
                ),
              },
              {
                id: 'fecha',
                Header: () => <TableHeader title="Fecha" blue center noEllipsis />,
                accessor: ({ registered_at }) => ({ registered_at }),
                Cell: ({ value: { registered_at }, index }) => (
                    <Data onClick={() => this.openRow(index)}>{moment(registered_at).format('DD MMM YYYY')}</Data>
                ),
              },
              {
                id: 'type',
                Header: () => <TableHeader title="Movimiento" blue noEllipsis center />,
                accessor: ({ total_formatted, type, discount }) => ({ total_formatted, type,discount }),
                Cell: ({ value: { total_formatted, type, discount }, index }) => (
                  <Type onClick={() => this.openRow(index)} type={type}>
                      { type === 'Payment' ?
                          `-${total_formatted}` :
                        type === 'Charge' && discount !== undefined && discount !== null?
                          formatPrice(discount.new_total,{symbol:'$'}) :
                          total_formatted
                      }
                  </Type>
                ),
              },
            ]}
          />
        ) :
          <TableLoading
            roundedCorners
            columns={[
              {
                id: 1,
                header: 'Descripción',
                element: 'Text',
                center: true,
              },
              {
                id: 2,
                header: 'Fecha',
                element: 'Text',
                center: true,
              },
              {
                id: 3,
                header: 'Movimiento',
                element: 'Text',
                center: true,
              }
            ]}
            rows={5}
          />
        }
      </TableContainer>
    )
  }
}
BalanceTable.defaultProps = {
}
const mapStateToProps = state => ({
})
export default connect(mapStateToProps,) (BalanceTable)



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/BalanceTable/index.jsx